import React, { useState } from "react";
import Layout from "../../../layout/Layout";
import axios from "axios";
import { useEffect, useRef } from "react";

import {
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Snackbar,
  Alert as MuiAlert,
  Typography,
  Divider,
  TextField,
  IconButton,
  Tooltip,
  Backdrop,
  Button,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  FileDownload as FileDownloadIcon,
} from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { config, statusAPI } from "../../../config";
import * as XLSX from "xlsx";
import { MaterialReactTable } from "material-react-table";
import moment from "moment";

function Settings() {
  const flagUseEffect = useRef(false);
  const [type, setType] = React.useState("");
  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [subTypeList, setSubTypeList] = React.useState([]);
  const [txtName, setTxtName] = useState("");
  const [txtPosition, setTxtPosition] = useState("");
  const [categoryID, setCategoryID] = useState(0);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isSubmitDisable, setIsSubmitDisable] = useState(false);
  const [txtStatus, setTxtStatus] = useState(1);
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  // MRT State
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //   const [txtName, setSubTypeList] = React.useState([]);
  //   const [txtPosition, setSubTypeList] = React.useState([]);
  const [typeList, setTypeList] = React.useState([]);

  useEffect(() => {
    // Only fetch Type list once on mount
    const data = JSON.stringify({
      limit: 0,
      offset: 0,
      parent_id: "1",
    });

    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        setTypeList(response.data["data"]);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    // Fetch paginated sub-categories with sorting and filtering
    const currentParentId = type === "" ? 1 : type;

    // Map MRT filters to API parameters
    const filterName = columnFilters.find(f => f.id === 'name')?.value || null;
    const filterPosition = columnFilters.find(f => f.id === 'position')?.value || null;
    const filterStatus = columnFilters.find(f => f.id === 'status')?.value || null;

    // Map MRT sorting
    const sortBy = sorting.length > 0 ? sorting[0].id : 'position';
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? 'DESC' : 'ASC') : 'ASC';

    const data = JSON.stringify({
      limit: pagination.pageSize,
      offset: pagination.pageIndex * pagination.pageSize,
      parent_id: currentParentId,
      txtSearch: globalFilter,
      sortBy: sortBy,
      sortOrder: sortOrder,
      filterName: filterName,
      filterPosition: filterPosition,
      filterStatus: filterStatus,
    });
    getStatus(data, currentParentId);
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, sorting, columnFilters, type]);

  const getStatus = (data, pType) => {
    setIsLoading(true);
    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        setSubTypeList(response.data["data"]);
        setTotalCount(response.data["count"] || 0);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const exportToExcel = () => {
    setIsExporting(true);
    const currentParentId = type === "" ? 1 : type;

    // Map MRT filters to API parameters
    const filterName = columnFilters.find(f => f.id === 'name')?.value || null;
    const filterPosition = columnFilters.find(f => f.id === 'position')?.value || null;
    const filterStatus = columnFilters.find(f => f.id === 'status')?.value || null;

    // Map MRT sorting
    const sortBy = sorting.length > 0 ? sorting[0].id : 'position';
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? 'DESC' : 'ASC') : 'ASC';

    const data = JSON.stringify({
      limit: 0, // Fetch all records for export
      offset: 0,
      parent_id: currentParentId,
      txtSearch: globalFilter,
      sortBy: sortBy,
      sortOrder: sortOrder,
      filterName: filterName,
      filterPosition: filterPosition,
      filterStatus: filterStatus,
    });

    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        const allData = response.data["data"];
        if (allData.length === 0) {
          setOpen(true);
          setMessageType("warning");
          setMessage("No data available to export");
          return;
        }

        const dataToExport = allData.map((item) => ({
          Type: item.name,
          Position: item.position,
          Status: item.status === 1 ? "Active" : "Inactive",
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Settings");
        XLSX.writeFile(workbook, `Settings_Export_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);

        setOpen(true);
        setMessageType("success");
        setMessage("Data exported successfully to Excel");
      })
      .catch(function (error) {
        console.log(error);
        setOpen(true);
        setMessageType("warning");
        setMessage("Failed to export data");
      })
      .finally(() => {
        setIsExporting(false);
      });
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const validationSchema = Yup.object().shape({
    // ddlType: Yup.string().required("Type is required"),
    txtPosition: Yup.string().required("Position is required"),
    // .matches(/^[0-9\s]+$/, "Only number are allowed"),
    txtName: Yup.string()
      .required("Name is required")
      .matches(/^[aA-zZ0-9\s]+$/, "Only alphabets & numeric are allowed")
      .min(2, "Name must be at least 2 characters")
      .max(60, "Name cannot be more than 60 characters"),
  });

  const formOptions = {
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  };
  const [open, setOpen] = React.useState(false);
  const { register, handleSubmit, formState, reset, setValue, getValues } =
    useForm(formOptions);

  const { errors } = formState;
  const handleChange = (event) => {
    setType(event.target.value);
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
    reset();
    setTxtName("");
    setTxtPosition("");
    setCategoryID(0);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  //   const navigate = useNavigate();
  function onSubmit(data) {
    setIsLoadingSubmit(true);
    setIsSubmitDisable(true);
    const responseData = JSON.stringify({
      name: data.txtName,
      position: data.txtPosition,
      parent_id: type === "" ? 1 : type,
      limit: 0,
      offset: 0,
      id: categoryID,
      status: txtStatus,
    });

    // var config = {
    //   method: "Post",
    //   url: "http://backend.imaginetventures.in/api/status",
    //   mode: "cors",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: "Bearer " + userData.token,
    //   },
    //   data: responseData,
    // };

    config.method = "Post";
    config.url = statusAPI;
    config.data = responseData;

    axios(config)
      .then(function (response) {
        console.log(response.data.message);
        reset();
        setTxtName("");
        setTxtPosition("");
        setOpen(true);
        setSubTypeList(response.data.data);
        setMessageType("success");
        setMessage(response.data.message);
        setIsSubmitDisable(false);
        setCategoryID(0);
        setTxtStatus(1);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setOpen(true);
        setMessageType("warning");
        setMessage(error.response.data.message);
        setIsSubmitDisable(false);
      })
      .finally(() => setIsLoadingSubmit(false));
  }

  const editSubCategory = (categoryID) => {
    setCategoryID(categoryID);
    const found = subTypeList.find((obj) => {
      return obj.id === categoryID;
    });
    setValue("txtName", found.name);
    setValue("txtPosition", found.position);
    setTxtName(found.name);
    setTxtPosition(found.position);
    setTxtStatus(found.status);
  };

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isLoadingSubmit}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <div className={`background--white`}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          Add / Edit
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={5} noPadding>
            <Grid item xs={12} md={3} lg={3}>
              <Autocomplete
                id="type-autocomplete"
                options={typeList}
                getOptionLabel={(option) => option.name || ""}
                value={typeList.find((r) => r.id === type) || null}
                onChange={(event, newValue) => {
                  const fakeEvent = { target: { value: newValue ? newValue.id : "" } };
                  handleChange(fakeEvent);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Type" variant="outlined" />
                )}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  name="txtName"
                  type="text"
                  label="Name"
                  value={txtName}
                  onChange={(e) => {
                    setTxtName(e.target.value);
                    setValue("txtName", e.target.value);
                  }}
                  // {...register("txtName")}
                  className={`form-control ${errors.txtName ? "is-invalid" : ""
                    }`}
                />
                <Typography className="invalid-feedback">
                  {errors.txtName?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  name="txtPosition"
                  type="text"
                  label="Position"
                  value={txtPosition}
                  onChange={(e) => {
                    setTxtPosition(e.target.value);
                    setValue("txtPosition", e.target.value);
                  }}
                  className={`form-control ${errors.txtPosition ? "is-invalid" : ""
                    }`}
                />
                <Typography className="invalid-feedback">
                  {errors.txtPosition?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3} sx={{ padding: 0 }}>
              <FormControl fullWidth>
                {/* <InputLabel id="demo-simple-select-helper-label">
                Status
              </InputLabel> */}
                <Select
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={txtStatus}
                  onChange={(e) => {
                    setTxtStatus(e.target.value);
                  }}
                  name="ddlType"
                >
                  <MenuItem value={`1`}>Active</MenuItem>
                  <MenuItem value={`0`}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              textAlign={`center`}
              className={`top-padding-0`}
            >
              <FormControl>
                {isSubmitDisable ? (
                  <Button
                    size="large"
                    variant="outlined"
                    color="primary"
                    type="button"
                  >
                    <CircularProgress size="1.5rem" />
                  </Button>
                ) : (
                  <Button
                    size="large"
                    variant="outlined"
                    color="primary"
                    type="submit"
                    className={`btn-primary`}
                  >
                    Submit
                  </Button>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </div>

      <Grid container spacing={2} sx={{ mb: 2, mt: 2, alignItems: "center" }}>
        <Grid item xs={12} md={6}>
          {/* Global search is now integrated in MaterialReactTable below */}
        </Grid>
        <Grid item xs={12} md={6} textAlign="right">
          <LoadingButton
            variant="contained"
            disableElevation
            loading={isExporting}
            startIcon={<FileDownloadIcon />}
            onClick={exportToExcel}
            className="btn-primary"
            sx={{ borderRadius: "5px" }}
          >
            Export to Excel
          </LoadingButton>
        </Grid>
      </Grid>

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <MaterialReactTable
            columns={[
              {
                accessorKey: "name",
                header: "Type",
              },
              {
                accessorKey: "position",
                header: "Position",
              },
              {
                accessorKey: "status",
                header: "Status",
                Cell: ({ cell }) => (
                  <Typography
                    className={`margin-auto ${cell.getValue() === 1 ? `active-status` : `inactive-status`
                      }`}
                  >
                    {cell.getValue() === 1 ? `Active` : `Inactive`}
                  </Typography>
                ),
                filterSelectOptions: [
                  { text: 'Active', value: 'Active' },
                  { text: 'Inactive', value: 'Inactive' },
                ],
                filterVariant: 'select',
              },
              {
                accessorKey: "id",
                header: "Edit",
                enableColumnFilter: false,
                enableSorting: false,
                Cell: ({ cell }) => (
                  <Tooltip title="Edit">
                    <IconButton onClick={() => editSubCategory(cell.getValue())}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            data={subTypeList}
            manualFiltering
            manualPagination
            manualSorting
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalCount}
            state={{
              columnFilters,
              globalFilter,
              isLoading: isLoading,
              pagination,
              sorting,
            }}
            enableGlobalFilter={true}
            muiTableContainerProps={{
              className: "settings-table-scroll",
              sx: {
                maxHeight: "520px",
                overflowY: "scroll",
                overflowX: "auto",
                scrollbarGutter: "stable",
              },
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid #e0e0e0",
              },
            }}
            muiTableHeadCellProps={{
              sx: {
                backgroundColor: "#f5f5f5",
                color: "#333",
                fontWeight: "bold",
              },
            }}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            enableHiding={false}
          />
        </Grid>
      </Grid>
    </Layout>
  );
}

export default Settings;
